
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";
import { required } from "vuelidate/lib/validators";
import { Hub } from "aws-amplify";

export default {
  components: {},
  data() {
    return {
      divisionId: null,
      counterId: null,
      roleId: null,
      moduleId: null,
      counters: [],
      divisions: [],
      userSession: { DivisionId: "", ServiceCounterId: "" },
      unsubscribeAuth: null,
      authState: "",
      userId: "",
      ShouldOverrideActiveSession: false,
    };
  },
  watch: {
    divisionId() {
      if (this.divisionId != null) {
        let index = this.divisions
          .map((item) => item.DivisionId)
          .indexOf(this.divisionId);
        this.counters = this.divisions[index].AssignedCounters;
      }
    },
  },
  created() {},
  validations: {
    divisionId: {
      required,
    },
    counterId: {
      required,
    },
  },
  beforeMount() {
    Hub.listen("auth", this.checkEvent);
  },
  mounted() {
    this.loadDataMain();    
  },

  methods: {
    checkEvent(data) {
      console.log("aws event", data.payload.event);
      switch (data.payload.event) {
        case "signIn":
          this.loadDataMain();
          break;
      }
    },

    async loadDataMain() {
      const rolesRequest = this.$axios.$get("user-roles/");
      const modulesRequest = this.$axios.$get("modules/");
      const [roles, modules] = await Promise.all([
        rolesRequest,
        modulesRequest,
      ]);
      this.roleId = roles.find(
        (x) => x.RoleName === "Service Point Officer"
      ).Id;
      this.moduleId = modules.find((x) => x.Name === "Service Point Module").Id;
      this.loadData();
    },

    async loadUserDivisions(id) {
      if (!this.divisions || this.divisions.length === 0) {
        const data = await this.$axios.$get(`user-divisions/${id}`);
        this.divisions = data;
      }
    },
    async loadData() {
      await this.createOrUpdateSession();
      await this.loadUserDivisions(this.userId);
    },
    async onContinueAction() {
      this.userSession.DivisionId = this.divisionId;
      this.userSession.ServiceCounterId = this.counterId;
      this.userSession.RoleId = this.roleId;
      this.userSession.ModuleId = this.moduleId;
      this.$axios
        .$post("user-sessions/", this.userSession)
        .then((userContext) => {
          this.$store.dispatch("setUserContext", {}).then((data) => {
            this.$store.dispatch("setUserContext", userContext).then((data) => {
              this.userId = userContext.Id;
              this.$router.push(`/active-queues/`);
            });
          });
        })
        .catch((error) => {
          this.ShouldOverrideActiveSession = true;
        });
    },
    async createOrUpdateSession() {
      this.userSession.DivisionId = this.divisionId;
      this.userSession.ServiceCounterId = this.counterId;
      this.userSession.RoleId = this.roleId;
      this.userSession.ModuleId = this.moduleId;
      const userContext = await this.$axios.$post(
        "user-sessions/",
        this.userSession
      );
      await this.$store.dispatch("setUserContext", {});
      await this.$store.dispatch("setUserContext", userContext);
      this.userId = userContext.Id;
    },
    onOk() {
      this.ShouldOverrideActiveSession = false;
    },
    onClose() {
      this.ShouldOverrideActiveSession = false;
    },
  },
};
